import React from 'react';
import { Modal } from '@stormwater-software/lib-ui';

export interface IClearComplianceByProjectModalProps {
  projects: any[];
  onClose: () => void;
  onConfirm: () => void;
  errorMsg?: string;
}

const ClearComplianceByProjectModal: React.FC<
  IClearComplianceByProjectModalProps
> = ({ projects, onClose, onConfirm, errorMsg }) => {
  return (
    <Modal
      title='Clear Compliance Certifications?'
      subTitle='Enabling "Required for Compliance Certification" will invalidate signed compliance certifications on the inspections listed below. Their compliance signatures will be removed. This action cannot be undone.'
      show={true}
      submitBtnText='Continue'
      handleSubmit={onConfirm}
      handleClose={onClose}
      cancelBtn={true}
      errorMsg={errorMsg}
    >
      <ul>
        {projects.map((p) => (
          <li key={p.project_id}>
            {p.project_name} — {p.inspection_count}{' '}
            {p.inspection_count === 1 ? 'inspection' : 'inspections'}
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default ClearComplianceByProjectModal;
